import { createRestSlice } from "./restSlice";

export type SimulationAgent = {
  id: string;
  userId: string;
  organizationId: string;
  agentId: string;
  name: string;
  systemPrompt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const simulationAgentSlice = createRestSlice<SimulationAgent>("simulationAgent", "/v1/simulationAgents");

export const simulationAgentReducer = simulationAgentSlice.reducer;
export const simulationAgentActions = simulationAgentSlice.actions;
